import React from 'react';
import Navbar from './home/Navbar';
import Footer from './Footer';
import PromoWorkbook from './PromoWorkbook';
import useGoogleAnalytics from '../hooks/useGoogleAnalytics';

function WorkbookPage() {
  const { events } = useGoogleAnalytics();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    events.pageView('Zendesk Workbook');
  }, [events]);

  return (
    <div className="flex flex-col min-h-screen bg-ink font-sans text-white antialiased">
      <Navbar />
      <div className="flex-grow pt-16">
        <PromoWorkbook />
      </div>
      <Footer />
    </div>
  );
}

export default WorkbookPage;
